//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SelectListSearch",
  props:{
    type:{
      type:String,
      default:""
    },
    prop:{
      type:String,
      default:""
    },
    label:{
      type:String,
      default:""
    },
    data:{
      type:null,
      default:""
    },
    placeholder:{
      type:String,
      default:""
    },

    list:{
      type:Array,
      default: () => []
    },
    //内嵌弹出框时需要调用的回调方法，用于判断内嵌的弹出框类型
    selectFun:{
      type:String,
      default :''
    }
  },
  data(){
    return{
      dialogVisible:false,
      returnData:'',//内嵌弹出框返回的数据
      embedData:{},//内嵌弹出框初始化数据
    }
  },
  created() {
    if(this.type=='O'){
      this.embedData=this[this.selectFun]();//this.selectFun为回调方法的名称，通过该名称调用全局方法
    }
  },
  mounted() {
  },
  methods:{
    updateReturnData(params,selectid){
      console.log('2019年11月11日21:53:38 SelectListSearch.vue[描述]——[params] :',params);
            this.returnData='';
      for(let returnData1 of params.returnData){
        if(this.returnData==''){
          this.returnData=returnData1[selectid];
        }else{
          this.returnData=this.returnData+";"+returnData1[selectid];
        }
      }
      // this.returnData=params.returnData[selectid]
    },
    beforeHandleClose(done) {
      this.$confirm('是否关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        done()
        this.$message({
          type: 'success',
          message: '关闭成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消关闭'
        })
      })
    },

  },
  watch:{
    'returnData':function(){
      this.dialogData=this.returnData;
    }
  },
  computed: {
    dialogData:{
      get:function(){
        return this.data;
      },
      set:function(){
        this.$emit('input',this.returnData)
      }
    },
    checkboxData:{
      get:function(){
        if(this.data==''){
          return [];
        }else{
          return this.data;
        }
      },
      set:function(val){
        this.$emit('input',val)
      }
    },
    currentdata:{
      get:function(){
        return this.data;
      },
      set:function(val){
        this.$emit('input',val)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pccomponents/SelectListSearch.vue